import api from './apiService';

class Bid {
  static get() {
    return api.get('/bids');
  }
}

export default Bid;



// WEBPACK FOOTER //
// ./src/api/bidApi.js